module.exports = __webpack_public_path__ + "static/media/GT05_ST_Room-Attributes.8743a94f.csv";